import TranslationService from "../services/TranslationService";
import NotificationService from "../services/NotificationService";
import { isNullOrUndefined } from "../helper/utils";
import Vue from "vue";
import OrderHistoryListItem from "./OrderHistoryListItem";

const ApiService = require("../services/ApiService");

export default Vue.component("order-history-list", {

    components:
    {
        OrderHistoryListItem
    },

    props:
    {
        template:
        {
            type: String,
            default: "#vue-order-history-list"
        },
        ordersPerPage:
        {
            type: Number,
            default: 10
        },
        allowPaymentProviderChange:
        {
            type: Boolean,
            default: false
        },
        allowReturn:
        {
            type: Boolean,
            default: true
        },
        initialData:
        {
            type: Object,
            default: null
        }
    },

    data()
    {
        return {
            waiting: false,
            orderList: {},
            page: 1,
            ordersWithErrors:[],
            orderIdsOnPage:[]
        };
    },
    created()
    {
        if (!isNullOrUndefined(this.initialData))
        {
            this.orderList = this.initialData;
        }
        else
        {
            this.setPage(1);

        }
    },

    methods:
    {

        scrollToElement(elementId)
        {
            const element = document.getElementById(elementId);

            if (element)
            {
                element.scrollIntoView({ behavior: "smooth" });
            }
        },
        setPage(page = 1)
        {
            if (!this.waiting)
            {
                this.waiting = true;

                const lastPage = this.orderList.page;

                this.orderList.page = page;

                ApiService.get("/rest/io/customer/order/list", { page: page, items: this.ordersPerPage })
                    .done(response =>
                    {
                        this.waiting = false;
                        this.orderList = response;
                        this.orderIdsOnPage = [];
                        const orderIds = [];

                        for (let i = 0; i < response.entries.length; i++)
                        {
                            orderIds.push(response.entries[i].id);
                        }
                        ApiService.post("/ordererror/customer/", { orderIds: orderIds })
                            .done(response =>
                            {
                                this.orderIdsOnPage = response;
                                setTimeout(()=>
                                {
                                    this.scrollToElement("order-history-list");
                                });
                            });
                    })
                    .fail(response =>
                    {
                        this.waiting = false;
                        this.orderList.page = lastPage;
                        NotificationService.error(
                            TranslationService.translate("Ceres::Template.returnHistoryOops")
                        );
                    });
            }
        }
    }
});
